import { Cookies } from "@/config/enums"
import { AppDataCookieSchema, TAppDataCookie } from "@/schemas/cookies"
import { ClusterSchema } from "@/schemas/user.schema"
import { syncStore$ } from "@/stores/sync.v2.store"
import type { IRegisterDocumentProps } from "@/sync/syncTypes"
import consola from "consola"
import { getCookie, setCookie } from "cookies-next/client"

export const ClusterDocumentHandler = (name: string): IRegisterDocumentProps => ({
  name,
  onFailure: (error: unknown) => {
    consola.error(`Document ${name} failed`, error)
  },
  onRemoved: () => {
    consola.debug(`Document removed: ${name}`)
  },
  onDocumentUpdated: (data: unknown, rawData: unknown) => {
    const parsedItem = ClusterSchema.safeParse(data)
    if (!parsedItem.success) {
      consola.error(`We will ignore the update from ${name} because the data is invalid`, parsedItem.error)
      return
    }

    syncStore$.cluster.set(parsedItem.data)

    const currentCookieDataResult = AppDataCookieSchema.safeParse(JSON.parse(getCookie(Cookies.Enum.appData) ?? "{}"))

    if (!currentCookieDataResult.success) {
      console.warn("Error parsing appData cookie: ", currentCookieDataResult.error)
      return
    }

    const updatedCookieData: TAppDataCookie = {
      ...currentCookieDataResult.data,
      launcherURL: parsedItem.data.launcherUrlS,
      remoteURL: parsedItem.data.remoteUrlS,
      adminURL: parsedItem.data.adminUrlS,
    }

    try {
      console.log(`Updating cookie with token ${JSON.stringify(updatedCookieData)}`)

      // setCookie(Cookies.Enum.appData, JSON.stringify(updatedCookieData), {
      //   httpOnly: false,
      //   secure: true,
      //   sameSite: "none",
      //   domain: ".ringio.com",
      // })

      setCookie(Cookies.Enum.appData, JSON.stringify(updatedCookieData), {
        httpOnly: false,
        secure: true,
        sameSite: "none",
        domain: ".ring.io",
      })
    } catch (err) {
      console.error("Error updating DynamoDB token in appData cookie: ", err)
      console.error("Cookie data: ", updatedCookieData)
    }

    consola.debug(`Updated state from ${name}`)
  },
})
